import classNames from "classnames";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import image from "../../assets/close.svg";
import { BrochureCartState, EDirection } from "../enums";
import { IBrochureTrayComponentProps } from "../types/props";
import BrochureCategorySlideComponent from "../categorySlideComponent/categorySlide.component";
import "./tray.component.scss";
class BrochureTrayComponent extends Component<IBrochureTrayComponentProps> {
  close = () => {
    this.props.closeTray();
  };

  continue = () => {
    this.props.continue();
  };

  removeSlide = (index: number) => {
    this.props.removeSlide(index);
    window.dispatchEvent(new Event("brochureStorage"));
  };

  render() {
    return ReactDOM.createPortal(
      <div>
        <div
          className={classNames({
            "pdf-tray": true,
            "pdf-tray--open": this.props.open,
            "pdf-tray--loading": this.props.cartState === BrochureCartState.LOADING,
          })}
        >
          <div
            className={classNames({
              "pdf-tray--header": true,
            })}
          >
            <span>
              <i>
                <span>{this.props.sections.length}</span>
              </i>
              Your Selections
            </span>
            <span className="pdf-tray--close">
              <button
                onClick={this.close}
                data-automation="global-brochure-pdf-tray-button-close"
              >
                {" "}
                <img src={`/dist/${image}`} />
              </button>
            </span>
          </div>
          {this.generateEmptyState()}
          {this.generateCategoryList()}
          {this.generateFooter()}
          {this.generateErrorState()}
        </div>
        <div
          onClick={this.close}
          className={classNames({
            "pdf-tray--screen-overlay": true,
            "pdf-tray--screen-overlay-active": this.props.open,
          })}
        ></div>
      </div>,
      document.getElementById("brochure-tray")
    );
  };

  generateCategoryList = () => {
    if (this.props.cartState !== BrochureCartState.LISTING) return null;
    return (
      <div className="pdf-tray--list titles">
        <ul>{this.categoryList()}</ul>
      </div>
    );
  };

  generateFooter = () => {
    return (
      <div className="pdf-tray--footer">
        <div className="pdf-tray--footer-buttons">
          <button
            className="ampri-button-primary"
            disabled={
              this.props.cartState === BrochureCartState.LOADING ||
              this.props.sections.length === 0
            }
            onClick={this.continue}
            data-automation="global-challenges-pdf-button-gather-info"
          >
            Continue
          </button>
          <button
            className="ampri-button-tertiary"
            onClick={this.close}
          >
            Add More Selections
          </button>
        </div>
      </div>
    );
  };

  generateEmptyState = () => {
    if (this.props.cartState !== BrochureCartState.EMPTY) return null;

    return (
      <div className="pdf-tray--empty">
        <p>Your Selections are Empty</p>
        <p>Add Selections to get started.</p>
      </div>
    );
  };

  generateErrorState = () => {
    if (this.props.cartState !== BrochureCartState.ERROR) return null;
    return (
      <div className="pdf-tray--error">
        <h3>Error</h3>
        <p>
          An error has occured, please try again or contact the site
          administrator.
        </p>
      </div>
    );
  };

  categoryList = (): JSX.Element[] => {
    // Sort the categories in a specific order.
    const categoryOrder = [
      'standard',
      'dual',
      'annual_lock',
      'contingent_return',
      'annual_fee',
      'dual_directional_w_annual_fee'
    ];
    this.props.indexedCategories.sort((a, b) => {
      const indexA = categoryOrder.indexOf(a);
      const indexB = categoryOrder.indexOf(b);
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });

    return this.props.indexedCategories.map((category, index) => {
      let sections = this.props.sections.filter((section) => section.meta.category === category);
      if (sections.length === 0) return null;
      return (
        <div className="image-view-link" key={index}>
          <BrochureCategorySlideComponent
            key={index}
            sections={sections.sort()}
            category={category}
            index={index}
            last={index === this.props.indexedCategories.length - 1}
            removeSlide={this.removeSlide}
          />
        </div>
      );
    });
  };
}

export default BrochureTrayComponent;
